// @flow

import React from 'react';

import { MenuPartCategory } from 'PMT/entities/menu';

import MenuPartMainCategoryView from './components/MenuPartMainCategoryView';

// -- views
import SelectItemsModal from './SelectItemsModal/SelectItemsModal';
import ModifyCategoryModal from './ModifyCategoryModal/ModifyCategoryModal';

export default class MenuPartEditView extends React.Component {
  state = {
    addModal: {
      show: false,
      forCategory: null,
    },
    modifyCategoryModal: {
      show: false,
      forCategory: null,
    },
  };

  //
  //
  //

  handleRunAdd = forCategory => {
    this.setState({
      addModal: {
        show: true,
        forCategory,
      },
    });
  };

  handleHideAdd = () => {
    this.setState({
      addModal: {
        show: false,
        forCategory: null,
      },
    });
  };

  handleAddItems = (forCategory, items) => {
    this.setState({
      addModal: {
        show: false,
        forCategory: null,
      },
    });

    // TODO: add items to the category.
  };

  //
  //
  //

  handleNewCategory = parentCategory => {
    this.setState({
      modifyCategoryModal: {
        show: true,
        isEditMode: false,
        forCategory: new MenuPartCategory(),
        parentCategory,
      },
    });
  }

  handleModifyCategory = forCategory => {
    this.setState({
      modifyCategoryModal: {
        show: true,
        isEditMode: true,
        forCategory,
      },
    });
  };

  handleHideModifyCategory = () => {
    this.setState({
      modifyCategoryModal: {
        show: false,
        forCategory: null,
      },
    });
  };

  //
  //
  //

  render() {
    const {
      menuPart,
      menu,
      restaurantMenu,
      orderSettings,
      onUpdate,
    } = this.props;

    return (
      <div>
        <h1
          style={{
            textAlign: 'center',
          }}
        >
          {menuPart.name}
        </h1>

        <MenuPartMainCategoryView
          menuInfo={{
            restaurantMenu,
            menu,
            menuPart,
            onRunAdd: this.handleRunAdd,
            onChange: this.props.onRestaurantMenuChange,
            level: 0,
            onNewCategory: this.handleNewCategory,
            onModifyCategory: this.handleModifyCategory,
            onAddCategory: this.props.onAddCategory,
            onDeleteCategory: this.props.onDeleteCategory,
          }}
        />

        {this.state.addModal.show && (
          <SelectItemsModal
            show
            category={this.state.addModal.forCategory}
            restaurantMenu={restaurantMenu}
            menuPart={menuPart}
            menu={menu}
            onHide={this.handleHideAdd}
            onSelect={this.handleAddItems}
          />
        )}

        {this.state.modifyCategoryModal.show && (
          <ModifyCategoryModal
            show
            isEditMode={this.state.modifyCategoryModal.isEditMode}
            category={this.state.modifyCategoryModal.forCategory}
            parentCategory={this.state.modifyCategoryModal.parentCategory}
            restaurantMenu={restaurantMenu}
            menuPart={menuPart}
            menu={menu}
            onHide={this.handleHideModifyCategory}
            onRemovePartCategoryImage={this.props.onRemovePartCategoryImage}
            onUploadPartCategoryImage={this.props.onUploadPartCategoryImage}
          />
        )}
      </div>
    );
  }
}
